module.exports = __webpack_public_path__ + "static/media/over2.4f1795ba.jpg";